import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { Button } from "$components";

import { useStyles } from "../DataTable.styles";
import { useDataDispatch, useDataPagination } from "../DataTableContext";

export const DataTablePagination = () => {
  const {
    pagination: { rowsPerPage, total, page },
  }: { pagination: { rowsPerPage: number; total: number; page: number } } =
    useDataPagination();
  const dispatch = useDataDispatch();
  const classes = useStyles();
  const pageCount = Math.ceil(total / rowsPerPage);

  const onPrevPage = () =>
    dispatch({ type: "setPage", payload: { page: page - 1 } });

  const onNextPage = () =>
    dispatch({ type: "setPage", payload: { page: page + 1 } });

  const onPageSelect = (pageNumber: number) =>
    dispatch({ type: "setPage", payload: { page: pageNumber } });

  // buttons pagination

  let buttons: any[];

  if (pageCount <= 7) {
    buttons = Array.from({ length: pageCount }).map((_, index) => index + 1);
  } else if (page < 4) {
    buttons = [
      ...Array.from({ length: 6 }).map((_, index) => index + 1),
      -1,
      pageCount,
    ];
  } else if (page > pageCount - 7) {
    buttons = [
      1,
      -1,
      ...Array.from({ length: 7 }).map((_, index) => index + pageCount - 6),
    ];
  } else {
    buttons = [1, -1, page - 1, page, page + 1, -1, pageCount];
  }

  return (
    <Box className={classes.paginationFooter}>
      <IconButton
        onClick={onPrevPage}
        disabled={page === 1}
        aria-label="previous page"
        data-testid="buttonPagePrevious"
      >
        <KeyboardArrowLeft />
      </IconButton>

      {buttons.map((i, index) => {
        return i === -1 ? (
          <span key={`page-ellipsis-${i}-${index}}`}>...</span>
        ) : (
          <Button
            key={`page-${i}}`}
            onClick={(e) => (page !== i ? onPageSelect(i) : e.preventDefault())}
            className={`${Number(page) !== i && "active"} page`}
            data-testid={`buttonPage-${i}`}
          >
            <span
              style={{
                padding: `0 ${(i + 1).toString().length >= 3 ? 4 : 0}px`,
              }}
            >
              {i}
            </span>
          </Button>
        );
      })}

      <IconButton
        onClick={onNextPage}
        disabled={page >= pageCount}
        aria-label="next page"
        data-testid="buttonPageNext"
      >
        <KeyboardArrowRight />
      </IconButton>
    </Box>
  );
};
